export default `<div>

    <p><img data-fr-image-pasted="true"
                    src="http://futurexcapital.com/storage/app/media/Picture1.jpg" class="fr-fic fr-dii"
                    style="width: 510px;"></p>



    <p><strong>Part 1:How to face Anxiety?&nbsp;</strong></p>

    <p class="img"><img data-fr-image-pasted="true"
            src="http://futurexcapital.com/storage/app/media/uploaded-files/1701316101693.jpeg" data-result="success"
            class="fr-fic fr-dii" style="width: 510px;"></p>

    <p>At this year's annual meeting, the FutureX team conducted a systematic interpretation of the current market
        situation, detailed the FutureX investment research system and future investment directions, and gave thematic
        presentations on investment opportunities in dollar investment, hard technology investment, and new generation
        AI applications.</p>

    <p>Founder Ms. Cynthia Zhang opened the meeting by summarizing FutureX's rapid development and growth over the past
        six years, analyzing FutureX's investment layout in conjunction with AI transformation and the macro
        environment.</p>

    <p>AI is developing rapidly day by day, but how should we face the anxiety it brings? Despite the fast pace of AI
        development, a comprehensive view reveals that technological development has its cycles, consistent with the
        nature of investment, so there is no need for excessive anxiety. By grasping the essence of the industry, the
        growth acceleration of technology companies is mainly due to a more pronounced growth flywheel, including lower
        computing costs, more powerful models, faster data processing capabilities, and improved user experiences. These
        factors together create high commercial barriers.</p>

    <p>FutureX's efforts over the past six years have accurately captured the industry leaders of three eras: mobile
        internet, cloud computing, and hard technology, precisely because it quickly identified and positioned itself in
        the core business essence of each new era. Ms. Cynthia Zhang stated: We believe that in the next ten years, we
        can replicate our past success, focusing on data and computing power-driven AI infrastructure and innovative
        applications, continuously discovering potential technology companies. Facing global changes, FutureX adheres to
        key elements: outstanding founders, data, and computing power, believing that great achievements are created by
        people.</p>



   <strong>Part 2:How to Seize Opportunities in the AI 2.0 Era?</strong>

    <p class="img"><img data-fr-image-pasted="true"
            src="http://futurexcapital.com/storage/app/media/uploaded-files/1701316162929.jpeg" data-result="success"
            class="fr-fic fr-dii" style="width: 510px;"></p>

    <p>Kingsoft Office CEO Mr. Qingyuan Zhang and Ms. Cynthia Zhang engaged in a dialogue centered on the theme
        'Opportunities and Prospects of China's ICT in the AI 2.0 Era.' WPS has been able to seize opportunities for
        rapid development in every cycle and has led Kingsoft Office to become a pioneer in the AI application industry.
        Mr. Qingyuan Zhang emphasized that the most important capability of AI — understanding unstructured data and
        programming ability — offers a vast imaginative space. It can have a disruptive impact on various industries,
        especially in the office sector. He also reminded entrepreneurs of the need to seize the moment. It's better to
        believe in the potential of AI than to doubt it. Actively embracing AI represents a tremendous opportunity and
        risk. He believes that many existing problems, including efficiency, cost, and computing power, will be resolved
        in the process of development, as the brightest minds and most resources are being invested in this area. If
        entrepreneurs don't wholeheartedly believe in AI, missing out on this could mean never being able to catch up
        again.</p>

    <p class="img"><img data-fr-image-pasted="true"
            src="http://futurexcapital.com/storage/app/media/uploaded-files/1701316188341.jpeg" data-result="success"
            class="fr-fic fr-dii" style="width: 510px;">

    </p>
    <p>During a review of Kingsoft Software's 35-year development journey, Vice President Ms. Bin Xiao also shared
        insights. She noted that the rapid growth of other companies under the wave of the internet did not tempt
        Kingsoft Office. Instead, it reinforced their determination to continue their entrepreneurial journey in office
        software. She emphasized the importance of sharing innovation, dreams, perseverance, and seizing opportunities,
        and encouraged maintaining an entrepreneurial spirit and firm beliefs to adapt to and lead technological
        changes.</p>

    <p class="img"><img data-fr-image-pasted="true"
            src="http://futurexcapital.com/storage/app/media/uploaded-files/1701316200033.jpeg" class="fr-fic fr-dii"
            style="width: 510px;">
        <br>
    </p>

    <p>Academician Prof. Qiang Yang of the International Association of Artificial Intelligence (AAAI) elaborated on the
        crucial role of federated learning in the AI 2.0 era. He highlighted its importance in protecting data privacy
        and security while promoting cross-institutional decision-making and data circulation. He particularly
        emphasized the role of trustworthy federated learning in enhancing model security, performance, and algorithmic
        efficiency. Furthermore, he explored the necessity of large models and federated large models in the context of
        privacy concerns and data scarcity. Looking to the future, he is optimistic about promoting model
        interoperability through open-source software, thus better unlocking the data value in the AI era.</p>

    <p class="img"><img data-fr-image-pasted="true"
            src="http://futurexcapital.com/storage/app/media/uploaded-files/1701316212697.jpeg" data-result="success"
            class="fr-fic fr-dii" style="width: 510px;"></p>

    <p>Mr. Chong Wu, the Chief Strategy Advisor of CICC Family Office and the founder of Adream Foundation, presented a
        philosophical perspective with his talk 'Social Challenges in the AI Era.' He offered a refreshing and
        alternative viewpoint on the impacts of artificial intelligence on society.</p>

    <strong>Part 3:Opportunities in Global Innovation and AI
                Applications</strong>

    <p class="img"><img data-fr-image-pasted="true"
            src="http://futurexcapital.com/storage/app/media/uploaded-files/1701316270727.jpeg" data-result="success"
            class="fr-fic fr-dii" style="width: 510px;"></p>

    <p>Chairman of NIO, William Li, joined the FutureX Annual Conference online to interact with the audience on the
        topic 'AI and the Transformation of the Automotive Industry.' From NIO's experience, the automotive industry,
        due to AI, is set to become a pinnacle of technological innovation once again. Vehicles will transform into
        mobile living spaces and emotional companions. The maturation of autonomous driving technology will free up user
        time and reduce accidents. This will not only have a significant impact on the automotive industry but will also
        bring positive progress to society as a whole.&nbsp;</p>

    <p class="img"><img data-fr-image-pasted="true"
            src="http://futurexcapital.com/storage/app/media/uploaded-files/1701316284906.jpeg" data-result="success"
            class="fr-fic fr-dii" style="width: 510px;">Mr. Xinhong Wu, Meitu's Founder, Chairman, and
        CEO, delivered a keynote speech titled 'The AI 2.0 Era: The Convergence of Technology and Art.' Meitu, through
        AI technological innovation, has deepened its application across multiple industries, promoting the integration
        of technology and art. The company continuously explores and progresses in the field of image productivity.
    </p>

    <p class="img"><img data-fr-image-pasted="true"
            src="http://futurexcapital.com/storage/app/media/uploaded-files/1701316298831.jpeg" data-result="success"
            class="fr-fic fr-dii" style="width: 510px;">
        <br>During his keynote speech on 'Material Science and Global Carbon Neutrality,' Prof. Yi Cui,
        Director of the
        Stanford Energy Center and a member of the National Academy of Sciences in the United States,
        pointed out the
        critical importance of artificial intelligence in the integration of energy systems. He
        emphasized that AI
        significantly aids in the discovery of energy materials, such as predicting material properties,
        providing
        innovative pathways for material science in achieving global carbon neutrality. This has a
        profound impact on
        sustainable development, science, and industry.
    </p>

    <strong>Part 4:Confluence of Perspectives Culminates in a Feast of
                Insights</strong>

    <p>During the conference, guests delved into the impacts and transformations AI is bringing across various sectors.
        From healthcare to energy, foundational software, industry, and beyond, AI is leading the way in innovation and
        change. At the panel discussion, entrepreneurs from diverse backgrounds converged on a singular topic, creating
        a banquet of thought-provoking discussions. They covered opportunities in semiconductors, foundational software,
        and AI's applications in energy, healthcare, and other fields.</p>

    <p class="img"><img data-fr-image-pasted="true"
            src="http://futurexcapital.com/storage/app/media/uploaded-files/1701316320474.jpeg" data-result="success"
            class="fr-fic fr-dii" style="width: 510px;"></p>

    <p>At the panel discussion titled 'Globalization and AI Applications in the Energy Sector,' four entrepreneurs with
        extensive industry knowledge in the new energy field shared their companies' cutting-edge innovative
        applications. The key focus was on how AI applications, especially multimodal large models, can enhance
        efficiency in the energy sector and break through some traditional challenges. The guests made a lasting
        impression by explaining specific application cases. Moreover, if multimodal large models can access more data,
        they could improve efficiency in tasks such as inspecting new energy sites and managing battery performance. On
        another level, the popularity of multimodal large models in the industrial sector is promoting the development
        of the Internet of Things (IoT) and the collection of more data.</p>

    <p class="img"><img data-fr-image-pasted="true"
            src="http://futurexcapital.com/storage/app/media/uploaded-files/1701316333047.jpeg" data-result="success"
            class="fr-fic fr-dii" style="width: 510px;"></p>

    <p>At this year's conference, attendees also visited the Kingsoft Innovation Museum, embarking on a journey through
        more than thirty years of Kingsoft's history and a forward-looking exploration of future city visions. Some
        portfolio companies set up exhibition centers, allowing investors to closely interact with their products and
        services. Notably, Lotus presented a luxury sports car test-driving experience for the guests. The thrilling
        speed and intelligent, user-friendly features left a lasting impression on the attendees.</p>

    <p class="img"><img data-fr-image-pasted="true"
            src="http://futurexcapital.com/storage/app/media/uploaded-files/1701316344539.jpeg" data-result="success"
            class="fr-fic fr-dii" style="width: 510px;">></p>


</div>`;
